import { render, staticRenderFns } from "./UPRList.vue?vue&type=template&id=102d064c&"
import script from "./UPRList.vue?vue&type=script&lang=js&"
export * from "./UPRList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports